import { Timestamp } from "@bufbuild/protobuf";

import { DateTime } from "luxon";

import { convertTimestampToDate } from "./time";

export const getUserLastSeen = (lastSeen: Timestamp | undefined) => {
  if (lastSeen) {
    const lastSeenDate = DateTime.fromJSDate(convertTimestampToDate(lastSeen));
    return `${lastSeenDate.toRelative()}`;
  } else {
    // user was created after org history's last seen data, so user has never logged in
    return "Not seen within last 12 months";
  }
};
